import { ALL_NUTRIENT_KEYS } from './nutrients';
import type { NutrientSources, NutrientValues } from './types';

export interface Estimated {
  per100g: NutrientValues;
  sources: NutrientSources;
  /** Cuántos valores se han rellenado. 0 = el genérico no aportaba nada nuevo. */
  filled: number;
}

/**
 * Rellena con un genérico los nutrientes que un producto NO declara (SPEC 5.4).
 *
 * Dos reglas, y ninguna es negociable:
 *
 *  1. Un valor que el producto ya trae NO se toca. Viene de su etiqueta; el
 *     genérico es una aproximación de otra cosa parecida.
 *  2. Lo que tampoco sabe el genérico sigue siendo `null`. Estimar no es
 *     inventar: un cero de relleno mentiría en la cobertura y en el histórico.
 *
 * Todo lo copiado queda marcado `estimado` para que la interfaz pueda decirlo.
 */
export function estimateMissing(
  product: { per100g: NutrientValues; sources: NutrientSources },
  generic: { per100g: NutrientValues },
): Estimated {
  const per100g: NutrientValues = { ...product.per100g };
  const sources: NutrientSources = { ...product.sources };
  let filled = 0;

  for (const key of ALL_NUTRIENT_KEYS) {
    if (product.per100g[key] != null) continue;
    const value = generic.per100g[key];
    if (value == null) continue;

    per100g[key] = value;
    sources[key] = 'estimado';
    filled++;
  }

  return { per100g, sources, filled };
}
